import Console from '@/libs/console';

/* User interface store */

export const state = () => ({
  dialog: {
    active: false,
    type: 'alert', // 'alert', 'question', 'error', 'success'
    title: '',
    text: '',
    buttons: []
  },
  navigation: {
    state: 'idle', // 'idle', 'loading', 'error', 'ready'
    main: [],
    user: [],
    aside: []
  },
  titleDetailsActive: false
});

export const mutations = {
  clearUiState(state) {
    state.dialog = {
      active: false,
      type: 'alert',
      title: '',
      text: '',
      buttons: []
    };
    state.navigation = {
      state: 'idle',
      main: [],
      user: [],
      aside: []
    };
    state.titleDetailsActive = false;
  },
  showDialog(state, options) {
    const { dialog } = state;
    dialog.type = options.type;
    dialog.title = options.title || '';
    dialog.text = options.text || '';
    dialog.buttons = options.buttons || [];
    dialog.active = true;
  },

  hideDialog(state) {
    state.dialog.active = false;
  },

  setNavigationState(state, value) {
    state.navigation.state = value;
  },

  setNavigation(state, { menuData, userData }) {
    const nav = state.navigation;
    const mainMenu = [];
    const userMenu = [];
    const mapMenu = [
      {
        type: 'MY_LIST',
        user: true,
        label: 'Minha lista',
        link: '/my-list',
        prop: '',
        getTypeCode: false
      },
      {
        type: 'MY_ACCOUNT',
        user: true,
        label: 'Minha conta',
        link: '/my-account',
        prop: '',
        getTypeCode: false
      },
      {
        type: 'MY_COURSES',
        user: true,
        label: 'Meu aprendizado',
        link: '/my-courses',
        prop: '',
        getTypeCode: false
      },
      {
        type: 'MY_LEARNING',
        user: true,
        label: 'Meu aprendizado',
        link: '/my-courses',
        prop: '',
        getTypeCode: false
      },
      {
        type: 'PURCHASE_HISTORY',
        user: true,
        label: 'Minhas compras',
        link: '/purchases',
        prop: '',
        getTypeCode: false
      },
      {
        type: 'LOGOUT',
        user: true,
        label: 'Sair',
        link: '/logout',
        prop: '',
        getTypeCode: false
      },
      {
        type: 'CHANNELS',
        user: false,
        label: 'Canais',
        link: '/channel/%id%',
        prop: 'id',
        getTypeCode: false
      },
      {
        type: 'MOVIES',
        user: false,
        label: 'Filmes',
        link: '/browse/%type%/%id%',
        prop: 'id',
        getTypeCode: true
      },
      {
        type: 'SERIES',
        user: false,
        label: 'Séries',
        link: '/browse/%type%/%id%',
        prop: 'id',
        getTypeCode: true
      },
      {
        type: 'COURSES',
        user: false,
        label: 'Cursos',
        link: '/browse/%type%/%id%',
        prop: 'id',
        getTypeCode: true
      },
      {
        type: 'VIDEOS',
        user: false,
        label: 'Vídeos',
        link: '/browse/%type%/%id%',
        prop: 'id',
        getTypeCode: true
      },
      {
        type: 'VIDEO_LESSONS',
        user: false,
        label: 'Lições',
        link: '/browse/%type%/%id%',
        prop: 'id',
        getTypeCode: true
      },
      {
        type: 'LECTURES',
        user: false,
        label: 'Aulas',
        link: '/browse/%type%/%id%',
        prop: 'id',
        getTypeCode: true
      },
      {
        type: 'CATEGORIES',
        user: false,
        label: 'Categorias',
        link: '/category/%id%',
        prop: 'categoryId',
        getTypeCode: false
      }
    ];
    let dataItems = [];
    if (menuData.showMenuContent && menuData?.menuContent?.length) {
      dataItems = dataItems.concat(menuData.menuContent);
    }
    if (menuData.showMenuInformation && menuData?.menuInformation?.length) {
      dataItems = dataItems.concat(menuData.menuInformation);
    }
    for (let a = 0, n = dataItems.length; a < n; a++) {
      const item = dataItems[a];
      const mapMenuItem = mapMenu.find((mitem) => mitem.type === item.type);
      const newItem = { type: item.type };
      if (mapMenuItem) {
        if (mapMenuItem.user) {
          newItem.label = mapMenuItem.label;
          newItem.link = mapMenuItem.link;
          // If user is anonymous, just add the logout link to user menu
          if (!userData.anonymous || mapMenuItem.type === 'LOGOUT') {
            userMenu.push(newItem);
          }
        } else {
          newItem.label = mapMenuItem.label;
          newItem.items = [];
          let { link } = mapMenuItem;
          if (mapMenuItem.getTypeCode) {
            link = link.replace(
              '%type%',
              this.$api.navigation.getContentTypeCode(mapMenuItem.type)
            );
          }
          for (let b = 0, bn = item?.items?.length; b < bn; b++) {
            const subitem = item.items[b];
            const id = subitem[mapMenuItem.prop];
            newItem.items.push({
              id,
              label: subitem.name || 'SubItem',
              link: link.replace('%id%', id),
              type: subitem.type || 'UNKNOWN'
            });
          }
          mainMenu.push(newItem);
        }
      } else {
        Console.log(`Menu type ignored: ${item.type}`);
      }
    }
    nav.user = userMenu.sort((a, b) => {
      const indexA = mapMenu.findIndex((mitem) => mitem.type === a.type);
      const indexB = mapMenu.findIndex((mitem) => mitem.type === b.type);
      return indexA - indexB;
    });
    nav.main = mainMenu;
    // nav.aside = data.aside || [];
    nav.state = 'ready';
  },

  setTitleDetailsActive(state, value) {
    state.titleDetailsActive = value;
  }
};

export const actions = {
  showDialog(context, options) {
    return new Promise((resolve) => {
      context.commit('showDialog', {
        type: options.type,
        title: options.title,
        text: options.text,
        buttons: options.buttons.map((bt) => ({
          primary: !!bt.primary,
          label: bt.label,
          value: bt.value,
          callback: (button) => {
            context.commit('hideDialog');
            if (bt.callback) {
              bt.callback(button);
            }
            resolve(button.value);
          }
        }))
      });
    });
  },

  showError(context, options) {
    return context.dispatch('showDialog', {
      type: 'error',
      title: options.title || 'Erro!',
      text: options.text,
      buttons: [
        {
          primary: true,
          value: true,
          label: 'OK',
          callback: options.callback
        }
      ]
    });
  },

  showAlert({ dispatch }, options) {
    return dispatch('showDialog', {
      type: 'alert',
      title: options.title || 'Alerta!',
      text: options.text,
      buttons: [{ primary: true, value: true, label: 'OK' }]
    });
  },

  showSuccess({ dispatch }, options) {
    return dispatch('showDialog', {
      type: 'success',
      title: options.title || 'Sucesso!',
      text: options.text,
      buttons: [{ primary: true, value: true, label: 'OK' }]
    });
  },

  showConfirmation({ dispatch }, options) {
    return dispatch('showDialog', {
      type: 'alert',
      title: options?.title || 'Confirmação',
      text: options?.text,
      buttons: options?.buttons || []
    });
  },

  getNavigation({ state, rootState, commit, dispatch }) {
    if (state.navigation.state === 'ready') {
      return Promise.resolve(state.navigation);
    }
    const distributorId = rootState.config.distributor.id;
    const userToken = rootState.user.session.token;
    commit('setNavigationState', 'loading');
    return this.$api.navigation
      .getAppLinks(distributorId, userToken)
      .then((response) => {
        if (response.code === 0 && response.data) {
          commit('setNavigation', {
            menuData: response.data,
            userData: rootState.user.user
          });
        }
        return Promise.resolve(state.navigation);
      })
      .catch((err) => {
        commit('setNavigationState', 'error');
        dispatch('consoleLog', err.message);
        return Promise.reject(err);
      });
  },

  consoleLog(message) {
    Console.log(message);
  }
};
